import axios from "@/plugins/axios";

export default {
    actions: {
        fetchSaleEmployeeDaily(context, searchItem) {
            let url = "sale_employee_dailies?page="  + searchItem.page

            if (!context.state.saleEmployeeDaily.isNeedFetch && !searchItem.isNeedFetch) {
                return
            }

            if (searchItem.byTotalSum) {
                url = url + '&order[totalSum]=desc'
            } else if (searchItem.byAverage) {
                url = url + '&order[average]=desc'
            } else if (searchItem.byReceiptAmount) {
                url = url + '&order[amount]=desc'
            } else if (searchItem.byIncome) {
                url = url + '&order[income]=desc'
            }

            if (searchItem.before) {
                url = url + '&dateTime[before]=' + searchItem.before
            }

            if (searchItem.after) {
                url = url + '&dateTime[after]=' + searchItem.after
            }

            if (searchItem.givenName) {
                url = url + "&person.givenName=" + searchItem.givenName
            }

            return axios.get(url)
                .then((response) => {
                    console.log(response)

                    let data = {
                        models: response.data['hydra:member'],
                        totalItems: response.data['hydra:totalItems']
                    }

                    context.commit('updateSaleEmployeeDaily', data)
                })
                .catch((err) => {
                    console.log(err)
                })
        },
    },
    mutations: {
        updateSaleEmployeeDaily(state, data) {
            state.saleEmployeeDaily = data
            state.saleEmployeeDaily.isNeedFetch = false
        },
    },
    state: {
        saleEmployeeDaily: {
            models: [],
            totalItems: 0,
            isNeedFetch: true
        },
    },
    getters: {
        getSaleEmployeeDaily(state) {
            return state.saleEmployeeDaily.models
        },
        getSaleEmployeeDailyTotalCount(state) {
            return state.saleEmployeeDaily.totalItems
        },
    },
}
